import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";
import {
  ref,
} from "vue";
import {getToken} from "@/scripts/Common";

interface CardNumberRange {
  minimumCardNumber: number,
  maximumCardNumber: number
}

interface AppSettings {
  currencyCode: string,
  cardNumberRange: CardNumberRange
}

const appSettings = ref<AppSettings>({
  currencyCode: 'EUR',
  cardNumberRange: {
    minimumCardNumber: 100000000,
    maximumCardNumber: 999999999
  }
});

const appSettingsError = ref<any>();
let loaded = false;

const loadAppSettings = async () => {
  if (loaded) return;
  loaded = true;

  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'appSettings',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
    }
  });

  if (response) {
    appSettings.value = response;
  }
  appSettingsError.value = error;
}

const useAppSettings = () => {
  loadAppSettings();

  return {
    appSettings,
    error: appSettingsError,
  }
}

export {
  useAppSettings
}

export type {
  AppSettings,
  CardNumberRange
}
